import { LearnerForm, LearnerFormType, parseLearnerFormToBackend } from './LearnerForm.tsx'
import { useDataProvider, useNotify } from 'react-admin'
import styles from './LearnerForm.module.scss'
import { useSubmitLoader } from '@src/logic/contexts/utils/SubmitContext.tsx'
import { useDocumentTitle } from '@src/hooks/useDocumentTitle.ts'
import Dialog from '@mui/material/Dialog'
import { useModal } from '@src/logic/contexts/Modal/ModalContext.tsx'

type CreateLearnerModalProps = {
  onClosed?: (reason: 'created' | 'cancelled') => void
}

export const LearnerCreate: React.FC<CreateLearnerModalProps> = ({ onClosed }) => {
  const { hideModal } = useModal()

  useDocumentTitle('Add New Learner')
  const dataProvider = useDataProvider()
  const notify = useNotify()
  const { isFormSubmitting, setIsFormSubmitting } = useSubmitLoader()

  const onSubmit = async (formData: LearnerFormType) => {
    if (isFormSubmitting) {
      return
    }

    setIsFormSubmitting(true)

    try {
      await dataProvider.create('Learner', {
        data: parseLearnerFormToBackend(formData),
      })

      // // Handle success case
      createdAndClose()
    } catch (error) {
      const errorMessage = error.message || 'Something went wrong, Please try again after sometime'
      notify(errorMessage, { type: 'error' })
    } finally {
      setIsFormSubmitting(false)
    }
  }

  const createdAndClose = () => {
    notify('Learner created successfully', { type: 'success' })
    // localStorage.removeItem('learnerCreateForm')
    onClosed?.('created')
    hideModal()
  }

  const clearAndClose = () => {
    // localStorage.removeItem('learnerCreateForm')
    onClosed?.('cancelled')
    hideModal()
  }

  return (
    <Dialog open role='dialog' aria-label='create-learner-dialog-title' maxWidth='md' fullWidth>
      <div className={styles.dialogHeader}>
        <h3 id='create-learner-dialog-title'>Add New Learner</h3>
      </div>

      <div data-page='create-user-model' className={styles.dialogContent}>
        <LearnerForm onSubmit={onSubmit} onCancel={clearAndClose} isSubmitting={isFormSubmitting}></LearnerForm>
      </div>
    </Dialog>
  )
}

export default LearnerCreate
